import "./style/index.scss";
import { Image, Tag } from "antd";
import icon from "./../../../util/assets/icon_login.png";
import React from "react";
import { ComparativoResultadoEmpresaModel } from "../../../models/comparativoResultado/comparativoResultadoEmpresaModel";
import dayjs from "dayjs";

dayjs.locale("pt-br");

const RelatorioComparativoEntreEmpresa = () => {
  //estados globais
  const entreEmpresa: ComparativoResultadoEmpresaModel[] = JSON.parse(localStorage.getItem("entreEmpresa")!);
  const filters: any = JSON.parse(localStorage.getItem("entreEmpresaFilter")!);

  const render = (value: ComparativoResultadoEmpresaModel[], level = 0) => {
    return value.map((a, index) => (
      <React.Fragment key={index}>
        <tr>
          <td className="ht-left" style={{ paddingLeft: `${20 * level}px`, width: 350, fontSize: "12px" }}>
            {a.denominacao}
          </td>
          {a.valorEmpresa1 !== null && (
            <td className="ht-right">
              {filters.porcentagem ? (
                <>
                  {a.percentualEmpresa1 ? (
                    <div className={Math.sign(parseInt(a.valorEmpresa1 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa1}</div>
                      <Tag>{a.percentualEmpresa1}</Tag>
                    </div>
                  ) : (
                    <div className={Math.sign(parseInt(a.valorEmpresa1 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa1}</div>
                      <div className="tagVazia"></div>
                    </div>
                  )}
                </>
              ) : (
                <div className={Math.sign(parseInt(a.valorEmpresa1 || "0")) === -1 ? "valorNegativo" : "rel_valor"}>{a.valorEmpresa1}</div>
              )}
            </td>
          )}
          {a.valorEmpresa2 !== null && (
            <td className="ht-right">
              {filters.porcentagem ? (
                <>
                  {a.percentualEmpresa2 ? (
                    <div className={Math.sign(parseInt(a.valorEmpresa2 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa2}</div>
                      <Tag>{a.percentualEmpresa2}</Tag>
                    </div>
                  ) : (
                    <div className={Math.sign(parseInt(a.valorEmpresa2 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa2}</div>
                      <div className="tagVazia"></div>
                    </div>
                  )}
                </>
              ) : (
                <div className={Math.sign(parseInt(a.valorEmpresa2 || "0")) === -1 ? "valorNegativo" : "rel_valor"}>{a.valorEmpresa2}</div>
              )}
            </td>
          )}
          {a.valorEmpresa3 !== null && (
            <td className="ht-right">
              {filters.porcentagem ? (
                <>
                  {a.percentualEmpresa3 ? (
                    <div className={Math.sign(parseInt(a.valorEmpresa3 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa3}</div>
                      <Tag>{a.percentualEmpresa3}</Tag>
                    </div>
                  ) : (
                    <div className={Math.sign(parseInt(a.valorEmpresa3 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa3}</div>
                      <div className="tagVazia"></div>
                    </div>
                  )}
                </>
              ) : (
                <div className={Math.sign(parseInt(a.valorEmpresa3 || "0")) === -1 ? "valorNegativo" : "rel_valor"}>{a.valorEmpresa3}</div>
              )}
            </td>
          )}
          {a.valorEmpresa4 !== null && (
            <td className="ht-right">
              {filters.porcentagem ? (
                <>
                  {a.percentualEmpresa4 ? (
                    <div className={Math.sign(parseInt(a.valorEmpresa4 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa4}</div>
                      <Tag>{a.percentualEmpresa4}</Tag>
                    </div>
                  ) : (
                    <div className={Math.sign(parseInt(a.valorEmpresa4 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa4}</div>
                      <div className="tagVazia"></div>
                    </div>
                  )}
                </>
              ) : (
                <div className={Math.sign(parseInt(a.valorEmpresa4 || "0")) === -1 ? "valorNegativo" : "rel_valor"}>{a.valorEmpresa4}</div>
              )}
            </td>
          )}
          {a.valorEmpresa5 !== null && (
            <td className="ht-right">
              {filters.porcentagem ? (
                <>
                  {a.percentualEmpresa5 ? (
                    <div className={Math.sign(parseInt(a.valorEmpresa5 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa5}</div>
                      <Tag>{a.percentualEmpresa5}</Tag>
                    </div>
                  ) : (
                    <div className={Math.sign(parseInt(a.valorEmpresa5 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa5}</div>
                      <div className="tagVazia"></div>
                    </div>
                  )}
                </>
              ) : (
                <div className={Math.sign(parseInt(a.valorEmpresa5 || "0")) === -1 ? "valorNegativo" : "rel_valor"}>{a.valorEmpresa5}</div>
              )}
            </td>
          )}
          {a.valorEmpresa6 !== null && (
            <td className="ht-right">
              {filters.porcentagem ? (
                <>
                  {a.percentualEmpresa6 ? (
                    <div className={Math.sign(parseInt(a.valorEmpresa6 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa6}</div>
                      <Tag>{a.percentualEmpresa6}</Tag>
                    </div>
                  ) : (
                    <div className={Math.sign(parseInt(a.valorEmpresa6 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa6}</div>
                      <div className="tagVazia"></div>
                    </div>
                  )}
                </>
              ) : (
                <div className={Math.sign(parseInt(a.valorEmpresa6 || "0")) === -1 ? "valorNegativo" : "rel_valor"}>{a.valorEmpresa6}</div>
              )}
            </td>
          )}
          {a.valorEmpresa7 !== null && (
            <td className="ht-right">
              {filters.porcentagem ? (
                <>
                  {a.percentualEmpresa7 ? (
                    <div className={Math.sign(parseInt(a.valorEmpresa7 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa7}</div>
                      <Tag>{a.percentualEmpresa7}</Tag>
                    </div>
                  ) : (
                    <div className={Math.sign(parseInt(a.valorEmpresa7 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa7}</div>
                      <div className="tagVazia"></div>
                    </div>
                  )}
                </>
              ) : (
                <div className={Math.sign(parseInt(a.valorEmpresa7 || "0")) === -1 ? "valorNegativo" : "rel_valor"}>{a.valorEmpresa7}</div>
              )}
            </td>
          )}
          {a.valorEmpresa8 !== null && (
            <td className="ht-right">
              {filters.porcentagem ? (
                <>
                  {a.percentualEmpresa8 ? (
                    <div className={Math.sign(parseInt(a.valorEmpresa8 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa8}</div>
                      <Tag>{a.percentualEmpresa8}</Tag>
                    </div>
                  ) : (
                    <div className={Math.sign(parseInt(a.valorEmpresa8 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa8}</div>
                      <div className="tagVazia"></div>
                    </div>
                  )}
                </>
              ) : (
                <div className={Math.sign(parseInt(a.valorEmpresa8 || "0")) === -1 ? "valorNegativo" : "rel_valor"}>{a.valorEmpresa8}</div>
              )}
            </td>
          )}
          {a.valorEmpresa9 !== null && (
            <td className="ht-right">
              {filters.porcentagem ? (
                <>
                  {a.percentualEmpresa9 ? (
                    <div className={Math.sign(parseInt(a.valorEmpresa9 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa9}</div>
                      <Tag>{a.percentualEmpresa9}</Tag>
                    </div>
                  ) : (
                    <div className={Math.sign(parseInt(a.valorEmpresa9 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa9}</div>
                      <div className="tagVazia"></div>
                    </div>
                  )}
                </>
              ) : (
                <div className={Math.sign(parseInt(a.valorEmpresa9 || "0")) === -1 ? "valorNegativo" : "rel_valor"}>{a.valorEmpresa9}</div>
              )}
            </td>
          )}
          {a.valorEmpresa10 !== null && (
            <td className="ht-right">
              {filters.porcentagem ? (
                <>
                  {a.percentualEmpresa10 ? (
                    <div className={Math.sign(parseInt(a.valorEmpresa10 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa10}</div>
                      <Tag>{a.percentualEmpresa10}</Tag>
                    </div>
                  ) : (
                    <div className={Math.sign(parseInt(a.valorEmpresa10 || "0")) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                      <div className="rel_valor">{a.valorEmpresa10}</div>
                      <div className="tagVazia"></div>
                    </div>
                  )}
                </>
              ) : (
                <div className={Math.sign(parseInt(a.valorEmpresa10 || "0")) === -1 ? "valorNegativo" : "rel_valor"}>{a.valorEmpresa10}</div>
              )}
            </td>
          )}
        </tr>
        {/* {a.sinteticoAnalitico === "S" && a.filhos && render(a.filhos, level + 1)} */}
      </React.Fragment>
    ));
  };

  const RelatorioHtml = React.forwardRef<HTMLDivElement>((_props, ref) => {
    return (
      <>
        <div ref={ref} className="relatorios-html-format">
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", gap: "24px" }}>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", marginTop: "24px", marginBottom: "24px", marginLeft: "14px" }}>
              <Image preview={false} height={50} src={icon} />
              <div className={"logoText"}>
                <div className="labelLogoGeral">
                  <span>GRUPO</span>
                </div>
                <div className="labelLogoGeral">
                  <span>PASCHOAL</span>
                </div>
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", marginTop: "24px", marginBottom: "24px" }}>
              <div style={{ fontSize: "14px", fontWeight: "bold" }}>RELATÓRIO DO RESULTADO - ENTRE EMPRESAS</div>
              <div style={{ display: "flex", flexDirection: "column", fontSize: "13px", marginTop: "10px", gap: "8px" }}>
                <div>
                  <span style={{ fontWeight: "bold" }}>Empresas:</span> {filters.empresasSelecionadas}
                </div>
                <div>
                  <span style={{ fontWeight: "bold" }}>Data do sorteio:</span> {dayjs(filters.dataSorteio).format("DD/MM/YYYY")}
                </div>
                <div>
                  <span style={{ fontWeight: "bold" }}>Tipo de resultado: </span>
                  {filters.tipoResultado === "E" ? "PONTO DE EQUILÍBRIO" : filters.tipoResultado === "P" ? "RESULTADO PARCIAL" : "RESULTADO FINAL"}
                </div>
              </div>
            </div>
          </div>
          <div className="rel-detalhe-entre-empresa">
            <table className="tb-dados">
              <thead>
                <tr className="header-table">
                  <th style={{ width: 350 }}></th>
                  {filters.empresasSelecionadas?.split(",").map((a: any) => (
                    <th className="ht-right">{a}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="body-table">{render(entreEmpresa)}</tbody>
            </table>
          </div>
        </div>
      </>
    );
  });

  return <RelatorioHtml />;
};

export default RelatorioComparativoEntreEmpresa;
